module.exports = __webpack_public_path__ + "img/Add.befa9bd7.svg";